<style lang="scss">
.ex-select {
  border-radius: 0.25rem;
  background: url("~@/assets/svg/sort-down.svg") no-repeat 98%;
  background-color: #fff;
  background-size: 24px;
  padding-right: 32px;
}
#ex-custom-select {
  .ex-select {
    &.disabled {
      background-color: #e9ecef;
    }
    span {
      display: block;
      overflow: hidden;
      max-height: 28px;
    }
  }
  ul {
    max-height: 200px;
    overflow-y: scroll;
    &.menu {
      position: absolute;
      z-index: 98;
      width: 100%;
      margin-top: 50px;
      padding: 0px;
      border-radius: 0.25rem;
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
    }
    li {
      list-style-type: none;
      span {
        display: block;
        padding: 6px 12px;
      }
      &:hover {
        background: #ced4da;
      }
      .v-input__control {
        width: 100%;
        .v-input__slot {
          margin-bottom: 0px;
        }
        i {
          padding-top: 10px;
          padding-bottom: 10px;
        }
        label {
          padding-top: 10px;
          padding-bottom: 10px;
          width: 100%;
        }
      }
    }
    .v-messages {
      display: none;
    }
    .v-input {
      margin-top: 0px;
    }
    hr {
      margin: 0;
    }
  }
}
</style>
<template>
  <div>
    <v-layout
      id="ex-custom-select"
      class="ex-custom-select relative select d-flex"
      :class="{'d-inline-flex': inline}"
      wrap
    >
      <div
        class="form-control ex-select"
        :class="[{ invalid: error }, {disabled: disabled}]"
        @click="toggleMenu"
      >
        <span :style="{width: width}">{{ label }}</span>
      </div>
      <ul class="menu pb-0" v-if="isShowMenu">
        <li v-for="(item, i) in items" :key="item.id" @click="update(item)">
          <span>{{item.value || item}}</span>
          <v-divider v-if="i != items.length - 1" />
        </li>
      </ul>
      <!-- <span style="display: none">{{label}}</span>
      <select
        :disabled="disabled"
        class="form-control ex-select"
        :class="{ invalid: error }"
        @change="updateParent($event)"
        v-model="label"
      >
        <option disabled selected value style="display: none">{{ label }}</option>
        <option
          v-for="(item, i) in items"
          :id="item.id"
          :value="item.value || item"
          :key="i"
        >{{ (item.id || item.id == 0) ? item.value : item }}</option>
      </select>
      <slot name="icon" />
    </v-layout>

    <div v-if="inline" class="relative select d-inline-flex">
      <span style="display: none">{{label}}</span>
      <select
        class="form-control ex-select"
        :class="{ invalid: error }"
        @change="updateParent($event)"
        v-model="label"
      >
        <option disabled selected value style="display: none">{{ label }}</option>
        <option
          v-for="(item, i) in items"
          :id="item.id"
          :value="item.value || item"
          :key="i"
        >{{ item.value || item }}</option>
      </select>
      <slot name="icon" />
      </div>-->
    </v-layout>
  </div>
</template>

<script>
import { parse } from "path";
export default {
  props: {
    items: Array,
    error: Boolean,
    model: [String, Number],
    id:  [String, Number],
    inline: Boolean,
    disabled: Boolean,
    width: String,
  },
  data() {
    return {
      selected: null,
      isShowMenu: false,
    };
  },
  created() {
    // if (this.model) this.selected = [...this.model];
    let vm = this;
    window.addEventListener("click", function(event) {
      if (
        (vm.isShowMenu &&
          !vm.hasSomeParentTheClass(event.target, "ex-custom-select")) ||
        vm.disabled
      ) {
        vm.isShowMenu = false;
      }
    });
  },
  computed: {
    label: {
      get: function() {
        if (this.id || this.id === 0)
          return this.items.find(x => x.id == this.id)
            ? this.items.find(x => x.id == this.id).value
            : "";
        return this.model;
      },
      set: function(val) {
        this.$emit("update:model", val);
      }
    }
  },
  watch: {
    items(value) {
      this.$el.querySelector(".ex-select").selectedIndex =
        this.items.findIndex(x => x.id == this.id) + 1;
    }
  },
  methods: {
    updateParent(e) {
      let value;
      let selected = e.target.children[e.target.selectedIndex];

      let id = parseInt(selected.id);
      this.$emit("update:id", id);

      if (selected.value && !isNaN(selected.value)) {
        value = parseInt(selected.value);
      } else value = selected.value;
      this.$emit("update:error", false);
      e.target.classList.remove("invalid");
      // this.$emit("update:model", value);
      this.$emit("change", selected);
    },
    hasSomeParentTheClass(element, classname) {
      if (
        element.className &&
        element.className.split(" ").indexOf(classname) >= 0
      )
        return true;
      return (
        element.parentNode &&
        this.hasSomeParentTheClass(element.parentNode, classname)
      );
    },
    toggleMenu() {
      this.isShowMenu = !this.isShowMenu;
    },
    update(item) {
      if (item.id || item.id === 0) {
        this.$emit("update:id", item.id);
        this.$emit("update:model", item.value);
      } else {
        this.$emit("update:model", item);
      }
      this.$emit("update:error", false);
      this.toggleMenu();
      this.$emit("change");
    }
  }
};
</script>
